import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import db from "../dbconn";
import fetch from "isomorphic-fetch";
import {API_ROOT, IMAGE_ROOT} from "../api-config";
import Modal from 'react-responsive-modal';

class NotFound404 extends Component{

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            windowHeight: 0,
            nosessionredirect:false,
            categoryList: [],
            open:false
        };
    };

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    componentWillMount() {

    }

    componentDidMount() {
        var height = $(window).height();
        this.setState({windowHeight: height});

        $('#home').css('background-image', 'none');
        $('#home').css('background-color', '#FFFFFF');
        $('#home').css('color', 'white !important');
        $('#home').css('text-align', 'center');
        $('#home').css('vertical-align','middle');
    }

    render(){

        const {open} = this.state;

        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        return(
            <div id="mainDiv" style={{textAlign:"center"}}>
                <h1 style={{fontSize: '42px', color: '#00599A'}}>Store Not Found.</h1>
                <img src={IMAGE_ROOT + "/img/takecharge-diner-logo.png"} alt="Takecharge Dinner Logo"/>
            </div>
        );
    }
}

export default NotFound404;


// WEBPACK FOOTER //
// ./src/view_components/notfound404.js